<template>
    <nav class="pre-consultation-navbar-secondary">
        <div class="navbar-content container-fluid px-proportal justify-content-center">
            <a v-if="imageUrl" href="/" class="pre-consultation-navbar-brand">
                <img class="img-fluid pre-consultation-navbar-brand-logo" :src="imageUrl" alt="Skin Masterclass Logo" />
            </a>
        </div>
    </nav>
    <div class="flex-grow-1">
        <div class="container mb-5">
            <router-view></router-view>
        </div>
    </div>
    <footer class="footer-public bg-primary py-4">
        <div class="container">
            <p class="text-center mb-0">
                <span>Powered by PRO Consult · Skin Masterclass®</span>
                <span v-if="logoAndCertNumber?.certificationNumber" class="d-block">License number: {{ logoAndCertNumber.certificationNumber }}</span>
            </p>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { usePortalPreConsultationsStore } from '../../store/pre-consultation';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';

const portalPreConsultationsStore = usePortalPreConsultationsStore();
const { logoAndCertNumber, currentPreconsultationId } = storeToRefs(portalPreConsultationsStore);

const route = useRoute()

const router = useRouter()

const imageUrl = ref('');

router.isReady().then(async() => {
    currentPreconsultationId.value = route.params.preconsultationId as string;
    
    if (route.name == "pre-consultation-client-self") {
        await portalPreConsultationsStore.loadLogoAndCertNumberAsConsultant(route.params.consultantId.toString())
    } else {
        await portalPreConsultationsStore.loadLogoAndCertNumber()
    }

    if (logoAndCertNumber.value && logoAndCertNumber.value.logo) {
        imageUrl.value = logoAndCertNumber.value.logo.url;
    } else {
        imageUrl.value = '/assets/images/skinmaster-logo-lg.png';
    }
});
</script>

<style lang="scss" scoped>
.pre-consultation-navbar-secondary {
    position: sticky;
    width: 100%;
    top: 0;
    z-index: $zindex-sticky + 1;
    // height: $proportal-secondary-navbar-height;
    padding: 1rem 0;
    border-bottom: 1px solid $gray-200;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    
    .navbar-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .pre-consultation-navbar-brand {
        display: flex;
        align-items: center;
    }

    .pre-consultation-navbar-brand-logo {
        height: 50px;
        width: 200px;
        object-fit: contain;

        @include media-breakpoint-up (lg) {
            height: 80px;
        }
    }
}
</style>